import React from 'react'
import { withRouter } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import { useImmer } from 'use-immer'

import routes from 'routes'
import ResponsiveSidebar from './responsiveSidebar'
import IntrigueFullLogo from 'assets/intrigue_logo.svg'
import IntrigueSmallIcon from 'assets/intrigue_icon.svg'
import FilterIssues from 'views/Issues/filter'
import FilterTechnologies from 'views/TechnologyBrowser/filter'

import './sidebar.scss'

const Sidebar = (props) => {
    const [state, setState] = useImmer({
        toggleSidebarMenu: false,
    })
    const isDesktop = useMediaQuery({ minWidth: 1025 })
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1024 })
    const isMobile = useMediaQuery({ maxWidth: 767 })
    const innerHeight = window.innerHeight

    const toggleMenuAction = () => {
        setState((draft) => {
            draft.toggleSidebarMenu = !state.toggleSidebarMenu
        })
    }

    const renderFilter = () => {
        switch (props.location.pathname) {
            case '/':
            case '/issues':
                return <FilterIssues />

            case '/technologies':
                return <FilterTechnologies />

            default:
                break
        }
    }

    return (
        <div
            id="sidebar-main"
            className="bg-neutral-gray-100 px-6 
            lg:fixed left-0 top-0 bottom-0 overflow-y-auto"
            style={{ width: '290px' }}
        >
            <div className="">
                <div className=" w-full">
                    <div className="w-full flex items-center mt-10 mb-16 ">
                        {isMobile ? (
                            <ResponsiveSidebar
                                toggleState={state.toggleSidebarMenu}
                                toggleMenu={toggleMenuAction}
                                {...props}
                            />
                        ) : null}
                        <div onClick={() => props.history.replace('/')}>
                            <img
                                width={isMobile ? '30' : '180'}
                                height={isMobile ? '30' : '180'}
                                className="max-w-none"
                                src={
                                    isMobile
                                        ? IntrigueSmallIcon
                                        : IntrigueFullLogo
                                }
                            />
                        </div>
                    </div>

                    {isTablet || isDesktop ? (
                        <React.Fragment>
                            <div className="w-full">
                                <div
                                    className={
                                        props.location.pathname ===
                                            routes.issues ||
                                        props.location.pathname === '/'
                                            ? ' py-3 px-4 rounded font-semibold text-navigation-link text-primary-purple-500 bg-primary-purple-100  border border-primary-purple-300 cursor-pointer'
                                            : 'py-3 px-4  font-semibold text-navigation-link text-neutral-gray-500 cursor-pointer'
                                    }
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        props.history.push(routes.issues)
                                    }}
                                >
                                    Issues
                                </div>
                                <div
                                    className={
                                        props.location.pathname ===
                                        routes.technologies
                                            ? 'mt-3 py-3 px-4 rounded font-semibold text-navigation-link text-primary-purple-500 bg-primary-purple-100 border border-primary-purple-300 cursor-pointer'
                                            : 'mt-3 py-3 px-4 font-semibold text-navigation-link text-neutral-gray-500 cursor-pointer'
                                    }
                                    href=""
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        props.history.push(routes.technologies)
                                    }}
                                >
                                    Technologies
                                </div>
                                <div
                                    className="bg-neutral-gray-200 mt-8 mb-6"
                                    style={{ height: '1px' }}
                                ></div>
                                <div className="">{renderFilter()}</div>
                                {/* <div className="ml-4 xl:ml-20">
                                    <a
                                        className={
                                            props.location.pathname ===
                                            routes.integrations
                                                ? 'font-medium pb-1 text-base xl:text-lg text-primary-500  border-b-2 border-primary-500'
                                                : 'font-medium text-black pb-1 text-base xl:text-lg hover:text-primary-500  border-b-2 border-transparent hover:border-primary-500'
                                        }
                                        href=""
                                        onClick={(e) => {
                                            e.preventDefault()
                                            props.history.replace(
                                                routes.integrations
                                            )
                                        }}
                                    >
                                        Integrations
                                    </a>
                                </div> */}
                            </div>
                        </React.Fragment>
                    ) : null}
                </div>
            </div>
        </div>
    )
}

export default withRouter(Sidebar)
